import { h } from "omi";

import { IconProps } from "../icons";

export function CheckHeartIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={props.width} height={props.height} viewBox="0 0 26 26">
      <path
        d="m9.955 12.258 1.929 2.068 4.654-4.34m-3.387-3.485c-1.917-2.405-5.227-3.15-7.805-1.098-2.578 2.051-3.056 5.615-1.178 8.214 1.418 1.963 5.503 5.946 7.417 7.778.352.337.528.505.738.576.183.062.388.07.574.02.215-.056.402-.212.777-.523 2.037-1.694 6.39-5.383 7.941-7.242 2.055-2.461 1.87-6.07-.602-8.276-2.472-2.206-5.783-1.715-7.862.551Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
